import { QueryResult, useQuery } from '@apollo/client';
import { GET_ROD_ROOMS } from '@bechtel/client-gql';
import { RodRoom } from '@bechtel/types';

export function useRodRoomListQuery(fetchFromNetwork?: boolean): QueryResult<{ rodRooms: RodRoom[] }> {
  const response = useQuery<{ rodRooms: RodRoom[] }, Record<string, any>>(
    GET_ROD_ROOMS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
